export default {
  title: 'Welkom',
  subtitle: 'Log in om je account en bestellingen te beheren',
  benefits: {
    earn_points: {
      title: 'Verdien punten bij elke bestelling',
      description: 'Verzamel punten en ontgrendel exclusieve beloningen',
    },
    get_deals: {
      title: 'Ontvang exclusieve kortingen',
      description: 'Gebruik je punten voor gratis items',
    },
    redeem_points: {
      title: 'Wissel punten in voor gratis eten',
      description: 'Krijg toegang tot exclusieve ledenaanbiedingen',
    },
  },
};
